import Layout from "@/layout/index.vue";
import { createRouter, createWebHistory } from "vue-router";
const MAXWIDTH = "1280px";
export const constantRoutes = [
    {
        path: "/login",
        name: "login",
        hidden: true,
        component: () => import("@/views/login/login.vue")
    },
    {
        path: "/modifyPassword",
        name: "modifyPassword",
        hidden: true,
        component: () => import("@/views/modifyPassword/index.vue")
    }
];
export const errorRoutes = [
    {
        path: "/404",
        name: "404",
        hidden: true,
        component: () => import("@/views/error/404.vue")
    },
    {
        path: "/403",
        name: "暂无权限",
        hidden: true,
        component: () => import("@/views/error/403.vue")
    },
    {
        path: "/:catchAll(.*)*",
        name: "NotFound",
        redirect: "/404"
    }
];
export const GPURoutes = [
    {
        path: "/resource",
        component: Layout,
        redirect: "/resource/storage",
        name: "resource-storage",
        hidden: true,
        meta: {
            title: "",
            roles: ["master", "sub"]
        },
        children: [
            {
                path: "storage",
                component: () => import("@/views/shareStorage/index.vue"),
                name: "shareStorage",
                hidden: true,
                meta: {
                    title: "并行文件存储EPFS",
                    roles: ["master", "sub"]
                }
            }
        ]
    },
    {
        path: "/chat",
        component: Layout,
        redirect: "/chat/index",
        name: "Chat",
        hidden: true,
        meta: {
            title: "Chat",
            roles: ["admin", "master", "sub"]
        },
        children: [
            {
                path: "index",
                component: () => import("@/views/chat/index.vue"),
                name: "chatIndex",
                meta: {
                    title: "Chat",
                    icon: "chat",
                    roles: ["admin", "master", "sub"]
                }
            }
        ]
    },
    {
        path: "/workbench",
        name: "workbench",
        isOpen: true,
        hidden: true,
        component: () => import("@/views/workbench/index.vue"),
        meta: {
            roles: ["master", "sub"]
        }
    }
];
export const accountRoutes = [
    {
        path: "/money",
        name: "money",
        meta: {
            hasSubMenu: true,
            title: "费用中心",
            roles: ["master"],
            icon: "money-off",
            activeIcon: "money-on"
        },
        children: [
            {
                path: "/finance",
                component: Layout,
                redirect: "/finance/overview",
                name: "finance",
                meta: {
                    icon: "dot-off",
                    activeIcon: "dot-on",
                    title: "费用概览",
                    roles: ["master"]
                },
                children: [
                    {
                        path: "overview",
                        component: () => import("@/views/finance/overview.vue"),
                        name: "overview",
                        meta: {
                            title: "费用概览",
                            roles: ["master"],
                            activeMenu: "/finance/overview",
                            activiteMenuTitle: "费用概览",
                            icon: "dot-off",
                            activeIcon: "dot-on"
                        }
                    },
                    {
                        path: "recharge",
                        component: () => import("@/views/finance/recharge.vue"),
                        name: "recharge",
                        hidden: true,
                        meta: {
                            title: "充值汇款",
                            back: true,
                            roles: ["master"],
                            activeMenu: "/finance/overview",
                            icon: "dot-off",
                            activeIcon: "dot-on",
                            activiteMenuTitle: "费用概览"
                        }
                    },
                    {
                        path: "incomeExpenditure",
                        component: () => import("@/views/finance/incomeExpenditure.vue"),
                        name: "incomeExpenditure",
                        hidden: true,
                        meta: {
                            title: "收支明细",
                            back: true,
                            roles: ["master"],
                            activeMenu: "/finance/overview",
                            icon: "dot-off",
                            activeIcon: "dot-on",
                            activiteMenuTitle: "费用概览"
                        }
                    },
                    {
                        path: "records",
                        component: () => import("@/views/finance/records.vue"),
                        name: "records",
                        hidden: true,
                        meta: {
                            title: "对公汇款记录",
                            back: true,
                            roles: ["master"],
                            activeMenu: "/finance/overview",
                            icon: "dot-off",
                            activeIcon: "dot-on",
                            activiteMenuTitle: "费用概览"
                        }
                    }
                ]
            },
            {
                path: "/expense",
                component: Layout,
                redirect: "/expense/bill",
                name: "expense",
                meta: {
                    title: "账单详情",
                    roles: ["master"],
                    icon: "dot-off",
                    activeIcon: "dot-on"
                },
                children: [
                    {
                        path: "bill",
                        component: () => import("@/views/finance/expense/index.vue"),
                        name: "expense-index",
                        hidden: true,
                        redirect: "/expense/bill/overview",
                        meta: {
                            title: "账单详情",
                            roles: ["master"],
                            activiteMenuTitle: "账单详情",
                            icon: "dot-off",
                            activeIcon: "dot-on"
                        },
                        children: [
                            {
                                path: "detail",
                                component: () => import("@/views/finance/expense/expense-detail.vue"),
                                name: "expense-detail",
                                hidden: true,
                                meta: {
                                    title: "账单详情",
                                    roles: ["master"],
                                    activiteMenuTitle: "账单详情",
                                    icon: "dot-off",
                                    activeIcon: "dot-on",
                                    activeMenu: "/expense"
                                }
                            },
                            {
                                path: "overview",
                                component: () => import("@/views/finance/expense/expense-overview.vue"),
                                name: "expense-overview",
                                hidden: true,
                                meta: {
                                    title: "账单详情",
                                    roles: ["master"],
                                    activiteMenuTitle: "账单详情",
                                    icon: "dot-off",
                                    activeIcon: "dot-on",
                                    activeMenu: "/expense"
                                }
                            }
                        ]
                    }
                ]
            },
            {
                path: "/coupon",
                component: Layout,
                redirect: "/coupon/index",
                name: "coupon",
                meta: {
                    title: "代金券",
                    roles: ["master"],
                    icon: "dot-off",
                    activeIcon: "dot-on"
                },
                children: [
                    {
                        path: "index",
                        component: () => import("@/views/finance/coupon.vue"),
                        name: "coupon-index",
                        meta: {
                            title: "代金券",
                            roles: ["master"],
                            activiteMenuTitle: "代金券",
                            icon: "dot-off",
                            activeIcon: "dot-on"
                        }
                    }
                ]
            },
            {
                path: "/sharedAccount",
                component: Layout,
                redirect: "/sharedAccount/index",
                name: "sharedAccount",
                meta: {
                    title: "账户共享",
                    roles: ["master"],
                    icon: "dot-off",
                    activeIcon: "dot-on"
                },
                children: [
                    {
                        path: "index",
                        component: () => import("@/views/finance/sharedAccount/index.vue"),
                        name: "sharedAccount-index",
                        meta: {
                            title: "账户共享",
                            roles: ["master"],
                            activiteMenuTitle: "账户共享",
                            icon: "dot-off",
                            activeIcon: "dot-on"
                        }
                    }
                ]
            }
        ]
    },
    {
        path: "/access",
        component: Layout,
        redirect: "/access/control",
        name: "access",
        meta: {
            icon: "access-off",
            activeIcon: "access-on",
            title: "访问控制",
            roles: ["master"]
        },
        children: [
            {
                path: "control",
                component: () => import("@/views/user/index.vue"),
                name: "access-control",
                hidden: true,
                redirect: "/access/control/user-list",
                meta: {
                    icon: "eos-off",
                    activeIcon: "eos-on",
                    title: "访问控制",
                    roles: ["master"]
                },
                children: [
                    {
                        path: "user-list",
                        component: () => import("@/views/user/list.vue"),
                        name: "user-list",
                        hidden: true,
                        meta: {
                            title: "用户",
                            roles: ["master"],
                            activeMenu: "/access"
                        }
                    },
                    {
                        path: "user-group-list",
                        component: () => import("@/views/userGroup/list.vue"),
                        name: "user-group-list",
                        hidden: true,
                        meta: {
                            title: "用户组",
                            icon: "group-off",
                            activeIcon: "group-on",
                            activeMenu: "/access",
                            roles: ["master"]
                        }
                    }
                ]
            },
            {
                path: "user-add",
                component: () => import("@/views/user/add.vue"),
                name: "user-add",
                hidden: true,
                meta: {
                    title: "创建用户",
                    back: true,
                    activeMenu: "/access",
                    activiteMenuTitle: "用户",
                    roles: ["master"]
                }
            },
            {
                path: "user-detail",
                component: () => import("@/views/user/detail.vue"),
                name: "user-detail",
                hidden: true,
                meta: {
                    title: "用户详情",
                    back: true,
                    activeMenu: "/access",
                    activiteMenuTitle: "用户",
                    roles: ["master"]
                }
            },
            {
                path: "user-group-add",
                component: () => import("@/views/userGroup/add.vue"),
                name: "user-group-add",
                hidden: true,
                meta: {
                    title: "创建用户组",
                    back: true,
                    activeMenu: "/access",
                    activiteMenuTitle: "用户组",
                    roles: ["master"]
                }
            },
            {
                path: "user-group-detail",
                component: () => import("@/views/userGroup/detail.vue"),
                name: "user-group-detail",
                hidden: true,
                meta: {
                    title: "用户组详情",
                    back: true,
                    activeMenu: "/access",
                    activiteMenuTitle: "用户组",
                    roles: ["master"]
                }
            }
        ]
    }
];
export const helpRoutes = [
    {
        path: "/concat",
        name: "concat",
        component: Layout,
        meta: {
            icon: "concat-off",
            title: "联系我们",
            roles: ["master", "sub"],
            external: "https://docs.ebtech.com/docs/contact.html"
        }
    },
    {
        path: "/question",
        name: "question",
        component: Layout,
        meta: {
            icon: "question-off",
            title: "常见问题",
            roles: ["master", "sub"],
            external: "https://docs.ebtech.com/docs/question/container.html"
        }
    }
];
export const publicRoutes = [
    {
        path: "/",
        name: "index",
        hidden: true,
        redirect: () => {
            const role = JSON.parse(localStorage.getItem("Roles") || "")[0];
            if (role === "master") {
                return { path: "/overview/index" };
            }
            else if (role === "sub") {
                return { path: "/cluster/index" };
            }
            else {
                return { path: "/admin/index" };
            }
        }
    },
    {
        path: "/personal",
        component: Layout,
        redirect: "/personal/index",
        name: "personal",
        meta: {
            icon: "user-off",
            activeIcon: "user-on",
            title: "账号设置",
            roles: ["admin", "master", "sub"]
        },
        children: [
            {
                path: "index",
                component: () => import("@/views/personal/index.vue"),
                name: "personal",
                meta: {
                    icon: "user-off",
                    activeIcon: "user-on",
                    title: "账号设置",
                    roles: ["admin", "master", "sub"]
                }
            },
            {
                path: "verify",
                component: () => import("@/views/personal/verify.vue"),
                name: "verify",
                hidden: true,
                meta: {
                    title: "企业认证",
                    roles: ["master", "sub"],
                    icon: "overview-off",
                    activeIcon: "overview-on",
                    back: true,
                    activeMenu: "/personal/index"
                }
            }
        ]
    },
    {
        path: "/message",
        component: Layout,
        redirect: "/message/index",
        hidden: true,
        name: "message",
        meta: {
            title: "消息列表",
            roles: ["admin", "master", "sub"]
        },
        children: [
            {
                path: "index",
                component: () => import("@/views/message/index.vue"),
                name: "messageList",
                meta: {
                    title: "消息列表",
                    icon: "message",
                    roles: ["admin", "master", "sub"],
                    breadcrumb: false
                }
            },
            {
                path: "detail",
                component: () => import("@/views/message/detail.vue"),
                name: "messageDetail",
                meta: {
                    title: "消息详情",
                    back: true,
                    icon: "messageDetail",
                    roles: ["admin", "master", "sub"]
                }
            }
        ]
    }
];
export const adminRoutes = [
    {
        path: "/register-approval",
        component: Layout,
        redirect: "/approval/register",
        name: "register-approval",
        meta: {
            title: "审核",
            roles: ["admin"],
            icon: "approval-off",
            activeIcon: "approval-on"
        },
        children: [
            {
                path: "register",
                component: () => import("@/views/approval/register.vue"),
                name: "register-approval",
                meta: {
                    title: "注册审核",
                    roles: ["admin"]
                }
            },
            {
                path: "firmVerify",
                component: () => import("@/views/approval/firmVerify.vue"),
                name: "firmVerify-approval",
                meta: {
                    title: "企业认证审核",
                    roles: ["admin"]
                }
            }
        ]
    },
    {
        path: "/admin",
        component: Layout,
        redirect: "/admin/index",
        name: "admin",
        meta: {
            title: "用户",
            roles: ["admin"]
        },
        children: [
            {
                path: "index",
                component: () => import("@/views/admin/index.vue"),
                name: "admin-index",
                meta: {
                    title: "用户",
                    icon: "user-off",
                    activeIcon: "user-on",
                    roles: ["admin"]
                }
            },
            {
                path: "detail",
                component: () => import("@/views/admin/detail.vue"),
                name: "adminDetail",
                hidden: true,
                meta: {
                    title: "用户详情",
                    back: true,
                    activeMenu: "/admin/index",
                    roles: ["admin"]
                }
            }
        ]
    },
    {
        path: "/quotaSetting",
        component: Layout,
        redirect: "/quotaSetting/index",
        name: "quotaSetting",
        meta: {
            title: "配额组设置",
            roles: ["admin"]
        },
        children: [
            {
                path: "index",
                component: () => import("@/views/quotaSetting/index.vue"),
                name: "quotaSetting",
                meta: {
                    title: "配额组设置",
                    icon: "user-off",
                    activeIcon: "user-on",
                    roles: ["admin"]
                }
            },
            {
                path: "add",
                component: () => import("@/views/quotaSetting/modifyQuotaSetting.vue"),
                name: "addQuotaSetting",
                hidden: true,
                meta: {
                    title: "创建配额组",
                    icon: "user-off",
                    activeIcon: "user-on",
                    roles: ["admin"]
                }
            },
            {
                path: "edit",
                component: () => import("@/views/quotaSetting/modifyQuotaSetting.vue"),
                name: "editQuotaSetting",
                hidden: true,
                meta: {
                    title: "编辑配额组",
                    back: true,
                    icon: "user-off",
                    activeMenu: "/quotaSetting/index",
                    activeIcon: "user-on",
                    roles: ["admin"]
                }
            },
            {
                path: "detail",
                component: () => import("@/views/quotaSetting/quotaSettingDetail.vue"),
                name: "quotaSettingDetail",
                hidden: true,
                meta: {
                    title: "配额组详情",
                    activeMenu: "/quotaSetting/index",
                    back: true,
                    roles: ["admin"]
                }
            },
            {
                path: "member",
                component: () => import("@/views/quotaSetting/memberManager.vue"),
                name: "memberManager",
                hidden: true,
                meta: {
                    title: "成员管理",
                    back: true,
                    activeMenu: "/quotaSetting/index",
                    roles: ["admin"]
                }
            }
        ]
    },
    {
        path: "/account",
        component: Layout,
        redirect: "/account/trade",
        name: "account",
        meta: {
            title: "交易查询",
            roles: ["admin"],
            icon: "jiaoyichaxun-off",
            activeIcon: "jiaoyichaxun-on"
        },
        children: [
            {
                path: "trade",
                component: () => import("@/views/account/trade.vue"),
                name: "account-trade",
                meta: {
                    title: "交易查询",
                    icon: "jiaoyichaxun-off",
                    activeIcon: "jiaoyichaxun-on",
                    roles: ["admin"]
                }
            }
        ]
    }
];
export const modelAppRoutes = [
    {
        path: "/model",
        component: Layout,
        redirect: "/model/market",
        name: "model",
        meta: {
            title: "模型",
            icon: "model-off",
            activeIcon: "model-on",
            roles: ["master", "sub"]
        },
        children: [
            {
                path: "mine",
                component: () => import("@/views/model/mine.vue"),
                name: "model-mine",
                hidden: true,
                meta: {
                    title: "我的模型",
                    activeMenu: "/model",
                    hiddenHeader: true,
                    roles: ["master", "sub"]
                }
            },
            {
                path: "market",
                component: () => import("@/views/model/market.vue"),
                name: "model-market",
                hidden: true,
                meta: {
                    title: "模型",
                    activeMenu: "/model",
                    roles: ["master", "sub"]
                }
            },
            {
                path: "detail/:id",
                component: () => import("@/views/model/modelInfo.vue"),
                name: "model-detail",
                hidden: true,
                meta: {
                    title: "模型详情",
                    activeMenu: "/model",
                    hiddenHeader: true,
                    roles: ["master", "sub"]
                },
                children: [
                    {
                        path: "introduce",
                        hidden: true,
                        component: () => import("@/views/model/components/introduce.vue"),
                        name: "model-introduce",
                        meta: {
                            activeMenu: "/model",
                            hiddenHeader: true,
                            roles: ["master", "sub"]
                        }
                    },
                    {
                        path: "document",
                        hidden: true,
                        component: () => import("@/pages/code/FileListPage.vue"),
                        name: "model-document",
                        meta: {
                            activeMenu: "/model",
                            hiddenHeader: true,
                            roles: ["master", "sub"]
                        }
                    },
                    {
                        path: "setup",
                        hidden: true,
                        component: () => import("@/views/model/components/setup.vue"),
                        name: "model-setup",
                        meta: {
                            activeMenu: "/model",
                            hiddenHeader: true,
                            roles: ["master", "sub"]
                        }
                    }
                ]
            },
            {
                path: "create",
                component: () => import("@/views/model/create.vue"),
                name: "model-create",
                hidden: true,
                meta: {
                    activeMenu: "/model",
                    title: "创建模型",
                    back: true,
                    activiteMenuTitle: "我的模型",
                    roles: ["master", "sub"]
                }
            }
        ]
    },
    {
        path: "/data-module",
        component: Layout,
        redirect: "/data-module/market",
        name: "data-module",
        meta: {
            title: "数据集",
            icon: "data-off",
            activeIcon: "data-on",
            roles: ["master", "sub"]
        },
        children: [
            {
                path: "mine",
                component: () => import("@/views/data/mine.vue"),
                name: "data-mine",
                hidden: true,
                meta: {
                    title: "我的数据集",
                    hiddenHeader: true,
                    activeMenu: "/data-module",
                    roles: ["master", "sub"]
                }
            },
            {
                path: "market",
                component: () => import("@/views/data/market.vue"),
                name: "data-market",
                hidden: true,
                meta: {
                    title: "数据集",
                    activeMenu: "/data-module",
                    roles: ["master", "sub"]
                }
            },
            {
                path: "detail/:id",
                component: () => import("@/views/data/dataInfo.vue"),
                name: "data-detail",
                hidden: true,
                meta: {
                    title: "数据集详情",
                    activeMenu: "/data-module",
                    hiddenHeader: true,
                    roles: ["master", "sub"]
                },
                children: [
                    {
                        path: "introduce",
                        hidden: true,
                        component: () => import("@/views/data/components/introduce.vue"),
                        name: "data-introduce",
                        meta: {
                            activeMenu: "/data-module",
                            hiddenHeader: true,
                            roles: ["master", "sub"]
                        }
                    },
                    {
                        path: "document",
                        hidden: true,
                        component: () => import("@/pages/code/FileListPage.vue"),
                        name: "data-document",
                        meta: {
                            activeMenu: "/data-module",
                            hiddenHeader: true,
                            roles: ["master", "sub"]
                        }
                    },
                    {
                        path: "setup",
                        hidden: true,
                        component: () => import("@/views/data/components/setup.vue"),
                        name: "data-setup",
                        meta: {
                            activeMenu: "/data-module",
                            hiddenHeader: true,
                            roles: ["master", "sub"]
                        }
                    }
                ]
            },
            {
                path: "create",
                component: () => import("@/views/data/create.vue"),
                name: "data-create",
                hidden: true,
                meta: {
                    title: "创建数据集",
                    back: true,
                    activeMenu: "/data-module",
                    activiteMenuTitle: "我的数据集",
                    roles: ["master", "sub"]
                }
            }
        ]
    },
    {
        path: "/train",
        component: Layout,
        redirect: "/train/codeMarket",
        name: "train",
        meta: {
            title: "算法中心",
            icon: "train-off",
            activeIcon: "train-on",
            roles: ["master", "sub"]
        },
        children: [
            {
                path: "myCode",
                component: () => import("@/views/train/myCode.vue"),
                name: "train-my-code",
                hidden: true,
                meta: {
                    title: "我的算法",
                    activeMenu: "/train",
                    hiddenHeader: true,
                    roles: ["master", "sub"]
                }
            },
            {
                path: "create",
                component: () => import("@/views/train/create.vue"),
                name: "trainCreate",
                hidden: true,
                meta: {
                    title: "创建算法",
                    back: true,
                    activeMenu: "/train",
                    activiteMenuTitle: "我的算法",
                    roles: ["master", "sub"]
                }
            },
            {
                path: "codeMarket",
                component: () => import("@/views/train/codeMarket.vue"),
                name: "codeMarket",
                hidden: true,
                meta: {
                    title: "算法广场",
                    activeMenu: "/train",
                    hiddenHeader: true,
                    roles: ["master", "sub"]
                }
            },
            {
                path: "codeDetail/:id",
                component: () => import("@/views/train/codeDetail.vue"),
                name: "train-code-detail",
                hidden: true,
                meta: {
                    title: "算法详情",
                    activeMenu: "/train",
                    hiddenHeader: true,
                    roles: ["master", "sub"]
                },
                children: [
                    {
                        path: "introduce",
                        hidden: true,
                        component: () => import("@/views/train/components/introduce.vue"),
                        name: "train-code-introduce",
                        meta: {
                            activeMenu: "/train",
                            hiddenHeader: true,
                            roles: ["master", "sub"]
                        }
                    },
                    {
                        path: "document",
                        hidden: true,
                        component: () => import("@/pages/code/FileListPage.vue"),
                        name: "train-code-document",
                        meta: {
                            activeMenu: "/train",
                            hiddenHeader: true,
                            roles: ["master", "sub"]
                        }
                    },
                    {
                        path: "setup",
                        hidden: true,
                        component: () => import("@/views/train/components/setup.vue"),
                        name: "train-code-setup",
                        meta: {
                            activeMenu: "/train",
                            hiddenHeader: true,
                            roles: ["master", "sub"]
                        }
                    }
                ]
            }
        ]
    },
    {
        path: "/task",
        component: Layout,
        redirect: "/task/taskModeling",
        name: "task",
        meta: {
            title: "训练开发",
            icon: "train-off",
            activeIcon: "train-on",
            roles: ["master", "sub"]
        },
        children: [
            {
                path: "taskModeling",
                component: () => import("@/views/train/taskModeling.vue"),
                name: "taskModeling",
                meta: {
                    activeMenu: "/task",
                    title: "训练开发",
                    icon: "space-off",
                    activeIcon: "space-on",
                    roles: ["master", "sub"],
                    breadcrumb: false
                }
            },
            {
                path: "add",
                component: () => import("@/views/train/add.vue"),
                name: "taskAdd",
                hidden: true,
                meta: {
                    title: "创建任务",
                    roles: ["master", "sub"],
                    back: true,
                    activeMenu: "/task"
                }
            },
            {
                path: "detail",
                component: () => import("@/views/train/taskDetail.vue"),
                name: "taskDetail",
                hidden: true,
                meta: {
                    title: "任务式建模详情",
                    roles: ["master", "sub"],
                    back: true,
                    activeMenu: "/task"
                }
            }
        ]
    },
    {
        path: "/inference",
        component: Layout,
        redirect: "/inference/onllineService",
        name: "inference",
        meta: {
            title: "服务部署",
            roles: ["master", "sub"],
            icon: "serve-off",
            activeIcon: "serve-on"
        },
        children: [
            {
                path: "onllineService",
                component: () => import("@/views/inference/service.vue"),
                redirect: "/inference/onllineService/market",
                name: "onllineService",
                hidden: true,
                meta: {
                    activeMenu: "/inference",
                    title: "服务部署",
                    roles: ["master", "sub"],
                    breadcrumb: false,
                    hiddenHeader: true
                },
                children: [
                    {
                        path: "market",
                        component: () => import("@/views/inference/market.vue"),
                        name: "service-market",
                        hidden: true,
                        meta: {
                            title: "服务广场",
                            roles: ["master", "sub"],
                            back: true,
                            activeMenu: "/inference"
                        }
                    },
                    {
                        path: "mine",
                        component: () => import("@/views/inference/onllineService.vue"),
                        name: "service-mine",
                        hidden: true,
                        meta: {
                            title: "我的服务",
                            roles: ["master", "sub"],
                            back: true,
                            activeMenu: "/inference"
                        }
                    }
                ]
            },
            {
                path: "add",
                component: () => import("@/views/inference/add.vue"),
                name: "serviceAdd",
                hidden: true,
                meta: {
                    title: "创建服务",
                    roles: ["master", "sub"],
                    back: true,
                    activeMenu: "/inference"
                }
            },
            {
                path: "edit",
                component: () => import("@/views/inference/edit.vue"),
                name: "serviceEdit",
                hidden: true,
                meta: {
                    title: "更新服务",
                    roles: ["master", "sub"],
                    back: true,
                    activeMenu: "/inference"
                }
            },
            {
                path: "detail",
                component: () => import("@/views/inference/serviceDetail.vue"),
                name: "serviceDetail",
                hidden: true,
                meta: {
                    title: "服务详情",
                    roles: ["master", "sub"],
                    back: true,
                    activeMenu: "/inference",
                    activiteMenuTitle: "我的服务"
                }
            },
            {
                path: "market-detail",
                component: () => import("@/views/inference/marketDetail.vue"),
                name: "market-detail",
                hidden: true,
                meta: {
                    title: "服务详情",
                    roles: ["master", "sub"],
                    back: true,
                    activeMenu: "/inference",
                    activiteMenuTitle: "服务广场"
                }
            },
            {
                path: "persetDetail",
                component: () => import("@/views/inference/components/persetDetail.vue"),
                name: "persetDetail",
                hidden: true,
                meta: {
                    title: "服务详情",
                    roles: ["master", "sub"],
                    back: true,
                    activeMenu: "/inference"
                }
            }
        ]
    },
    {
        path: "/application",
        component: Layout,
        redirect: "/application/market",
        name: "application-center",
        meta: {
            title: "应用中心",
            icon: "appliance-off",
            activeIcon: "appliance-on",
            roles: ["master", "sub"]
        },
        children: [
            {
                path: "mine",
                component: () => import("@/views/application/mine.vue"),
                name: "application-mine",
                hidden: true,
                meta: {
                    activeMenu: "/application",
                    title: "我的应用",
                    hiddenHeader: true,
                    roles: ["master", "sub"]
                },
                children: []
            },
            {
                path: "market",
                component: () => import("@/views/application/market.vue"),
                name: "application-market",
                hidden: true,
                meta: {
                    activeMenu: "/application",
                    title: "应用广场",
                    hiddenHeader: true,
                    roles: ["master", "sub"]
                }
            },
            {
                path: "experience",
                component: () => import("@/views/application/experience.vue"),
                name: "application-experience",
                hidden: true,
                meta: {
                    activeMenu: "/application",
                    title: "应用体验",
                    roles: ["master", "sub"],
                    hiddenHeader: true
                }
            },
            {
                path: "add",
                component: () => import("@/views/application/add.vue"),
                name: "application-add",
                hidden: true,
                meta: {
                    activeMenu: "/application",
                    title: "新增应用",
                    hiddenHeader: true,
                    roles: ["master", "sub"]
                }
            }
        ]
    },
    {
        path: "/knowledge",
        component: Layout,
        redirect: "/knowledge/index",
        name: "knowledge",
        meta: {
            title: "知识库",
            icon: "knowledge-off",
            activeIcon: "knowledge-on",
            roles: ["master", "sub"]
        },
        children: [
            {
                path: "index",
                component: () => import("@/views/knowledge/index.vue"),
                name: "knowledge-index",
                hidden: true,
                meta: {
                    activeMenu: "/knowledge",
                    title: "知识库",
                    roles: ["master", "sub"],
                    breadcrumb: false
                }
            },
            {
                path: "add",
                component: () => import("@/views/knowledge/add.vue"),
                name: "knowledge-add",
                hidden: true,
                meta: {
                    activeMenu: "/knowledge",
                    title: "创建知识库",
                    back: true,
                    roles: ["master", "sub"]
                }
            },
            {
                path: "edit",
                component: () => import("@/views/knowledge/edit.vue"),
                name: "knowledge-edit",
                hidden: true,
                meta: {
                    activeMenu: "/knowledge",
                    title: "编辑知识库",
                    back: true,
                    roles: ["master", "sub"]
                }
            },
            {
                path: "detail",
                redirect: "/detail/:id",
                name: "knowledge-detail",
                hidden: true,
                meta: {
                    activeMenu: "/knowledge",
                    title: "知识库详情",
                    roles: ["master", "sub"]
                },
                children: [
                    {
                        path: ":id",
                        component: () => import("@/views/knowledge/detail.vue"),
                        name: "knowledge-detail-index",
                        hidden: true,
                        meta: {
                            activeMenu: "/knowledge",
                            title: "知识库详情",
                            back: true,
                            breadcrumb: false,
                            roles: ["master", "sub"]
                        }
                    },
                    {
                        path: ":id/fileSlices",
                        component: () => import("@/views/knowledge/fileSlices.vue"),
                        name: "file-slices",
                        hidden: true,
                        meta: {
                            activeMenu: "/knowledge",
                            title: "查看文件",
                            back: true,
                            roles: ["master", "sub"]
                        }
                    }
                ]
            }
        ]
    },
    {
        path: "/modelToken",
        component: Layout,
        redirect: "/modelToken/index",
        name: "model-token",
        meta: {
            title: "访问令牌",
            roles: ["master", "sub"]
        },
        children: [
            {
                path: "index",
                component: () => import("@/views/personal/token.vue"),
                name: "model-token-index",
                meta: {
                    title: "访问令牌",
                    roles: ["master", "sub"],
                    icon: "log-off",
                    activeIcon: "log-on",
                    breadcrumb: false
                }
            }
        ]
    }
];
export const resourceRoutes = [
    {
        path: "/overview",
        component: Layout,
        redirect: "/overview/index",
        name: "container-overview",
        meta: {
            icon: "view-off",
            activeIcon: "view-on",
            title: "工作台",
            roles: ["master"]
        },
        children: [
            {
                path: "index",
                component: () => import("@/views/containerService/cluster/overview.vue"),
                name: "overview-index",
                meta: {
                    icon: "view-off",
                    activeIcon: "view-on",
                    title: "工作台",
                    roles: ["master"],
                    breadcrumb: false
                }
            }
        ]
    },
    {
        path: "/cluster",
        component: Layout,
        redirect: "/container/index",
        name: "cluster",
        meta: {
            title: "集群",
            roles: ["master", "sub"]
        },
        children: [
            {
                path: "index",
                component: () => import("@/views/containerService/cluster/index.vue"),
                name: "clusterList",
                meta: {
                    icon: "cluster-off",
                    activeIcon: "cluster-on",
                    title: "集群",
                    roles: ["master", "sub"],
                    breadcrumb: false
                }
            },
            {
                path: "create",
                component: () => import("@/views/containerService/cluster/createCluster.vue"),
                name: "cluster-add",
                hidden: true,
                meta: {
                    title: "创建集群",
                    maxWidth: MAXWIDTH,
                    back: true,
                    activeMenu: "/cluster/index",
                    roles: ["master", "sub"]
                }
            },
            {
                path: "",
                component: () => import("@/views/containerService/cluster/overdetail.vue"),
                name: "cluster-overdetail",
                hidden: true,
                redirect: "/cluster/detail",
                meta: {
                    title: "集群详情",
                    back: true,
                    roles: ["master", "sub"]
                },
                children: [
                    {
                        path: "detail",
                        component: () => import("@/views/containerService/cluster/detail.vue"),
                        name: "cluster-detail",
                        hidden: true,
                        meta: {
                            title: "集群详情",
                            activeMenu: "/cluster/index",
                            roles: ["master", "sub"]
                        }
                    },
                    {
                        path: "config",
                        component: () => import("@/views/containerService/cluster/config.vue"),
                        name: "cluster-config",
                        hidden: true,
                        meta: {
                            title: "集群详情",
                            activeMenu: "/cluster/index",
                            roles: ["master", "sub"]
                        }
                    }
                ]
            }
        ]
    },
    {
        path: "/memory",
        name: "memory",
        meta: {
            hasSubMenu: true,
            icon: "eos-off",
            activeIcon: "eos-on",
            alwaysShow: true,
            title: "存储",
            roles: ["master", "sub"]
        },
        children: [
            {
                path: "/storage",
                component: Layout,
                name: "EPFS",
                meta: {
                    title: "共享存储卷",
                    roles: ["master", "sub"]
                },
                children: [
                    {
                        path: "index",
                        component: () => import("@/views/containerService/EPFS/index.vue"),
                        name: "EPFS-index",
                        meta: {
                            icon: "dot-off",
                            activeIcon: "dot-on",
                            title: "共享存储卷",
                            activiteMenuTitle: "共享存储卷",
                            roles: ["master", "sub"],
                            breadcrumb: false
                        }
                    },
                    {
                        path: "create",
                        component: () => import("@/views/containerService/EPFS/createStorage.vue"),
                        name: "createStorage",
                        hidden: true,
                        meta: {
                            title: "创建存储卷",
                            back: true,
                            maxWidth: MAXWIDTH,
                            activiteMenuTitle: "共享存储卷",
                            activeMenu: "/storage/index",
                            roles: ["master", "sub"]
                        }
                    }
                ]
            },
            {
                path: "/blockStorage",
                component: Layout,
                name: "BLOCK",
                meta: {
                    title: "块存储卷",
                    roles: ["master", "sub"]
                },
                children: [
                    {
                        path: "index",
                        component: () => import("@/views/containerService/blockStorage/index.vue"),
                        name: "block-index",
                        meta: {
                            icon: "dot-off",
                            activeIcon: "dot-on",
                            title: "块存储卷",
                            activiteMenuTitle: "块存储卷",
                            roles: ["master", "sub"],
                            breadcrumb: false
                        }
                    },
                    {
                        path: "create",
                        component: () => import("@/views/containerService/blockStorage/createStorage.vue"),
                        name: "createBlockStorage",
                        hidden: true,
                        meta: {
                            title: "创建块存储卷",
                            back: true,
                            maxWidth: MAXWIDTH,
                            activiteMenuTitle: "块存储卷",
                            activeMenu: "/blockStorage/index",
                            roles: ["master", "sub"]
                        }
                    }
                ]
            },
            {
                path: "/resource",
                component: Layout,
                redirect: "/resource/objectStorage",
                name: "resource-objectStorage",
                meta: {
                    icon: "dot-off",
                    activeIcon: "dot-on",
                    title: "对象存储",
                    roles: ["master"]
                },
                children: [
                    {
                        path: "objectStorage",
                        component: () => import("@/views/objectStorage/index.vue"),
                        name: "objectStorage-index",
                        hidden: true,
                        redirect: "/resource/objectStorage/list",
                        meta: {
                            icon: "dot-off",
                            activeIcon: "dot-on",
                            activiteMenuTitle: "对象存储",
                            title: "对象存储",
                            roles: ["master"]
                        },
                        children: [
                            {
                                path: "list",
                                component: () => import("@/views/objectStorage/objectStorage.vue"),
                                name: "objectStorage-list",
                                hidden: true,
                                meta: {
                                    title: "对象存储",
                                    activiteMenuTitle: "对象存储",
                                    roles: ["master"],
                                    activeMenu: "/resource"
                                }
                            },
                            {
                                path: "secretKey",
                                component: () => import("@/views/objectStorage/secretKey.vue"),
                                name: "objectStorage-secretKey",
                                hidden: true,
                                meta: {
                                    title: "对象存储",
                                    activiteMenuTitle: "对象存储",
                                    roles: ["master"],
                                    activeMenu: "/resource"
                                }
                            }
                        ]
                    },
                    {
                        path: "detail",
                        component: () => import("@/views/objectStorage/objectStorageDetail.vue"),
                        name: "objectStorageDetail",
                        hidden: true,
                        meta: {
                            title: "存储桶详情",
                            back: true,
                            activiteMenuTitle: "对象存储",
                            activeMenu: "/resource",
                            roles: ["master"]
                        }
                    },
                    {
                        path: "createBucket",
                        component: () => import("@/views/objectStorage/createBucket.vue"),
                        name: "createBucket",
                        hidden: true,
                        meta: {
                            title: "创建存储桶",
                            back: true,
                            maxWidth: MAXWIDTH,
                            activiteMenuTitle: "对象存储",
                            activeMenu: "/resource",
                            roles: ["master"]
                        }
                    }
                ]
            }
        ]
    },
    {
        path: "/ssh",
        redirect: "/ssh/index",
        component: Layout,
        name: "ssh",
        meta: {
            title: "开发机",
            roles: ["master", "sub"]
        },
        children: [
            {
                path: "index",
                component: () => import("@/views/containerService/ssh/index.vue"),
                name: "ssh-list",
                meta: {
                    icon: "ssh-off",
                    activeIcon: "ssh-on",
                    title: "开发机",
                    roles: ["master", "sub"],
                    breadcrumb: false
                }
            },
            {
                path: "add",
                component: () => import("@/views/containerService/ssh/add.vue"),
                name: "ssh-add",
                hidden: true,
                meta: {
                    title: "创建开发机",
                    maxWidth: MAXWIDTH,
                    back: true,
                    activeMenu: "/ssh/index",
                    roles: ["master", "sub"]
                }
            },
            {
                path: "detail",
                component: () => import("@/views/containerService/ssh/detail.vue"),
                name: "ssh-detail",
                hidden: true,
                meta: {
                    title: "开发机详情",
                    back: true,
                    activeMenu: "/ssh/index",
                    roles: ["master", "sub"]
                }
            },
            {
                path: "edit",
                component: () => import("@/views/containerService/ssh/edit.vue"),
                name: "ssh-edit",
                hidden: true,
                meta: {
                    title: "更改实例配置",
                    back: true,
                    maxWidth: MAXWIDTH,
                    activeMenu: "/ssh/index",
                    roles: ["master", "sub"]
                }
            }
        ]
    },
    {
        path: "/extend",
        redirect: "/extend/index",
        component: Layout,
        name: "extend",
        meta: {
            title: "扩展组件",
            roles: ["master", "sub"]
        },
        children: [
            {
                path: "index",
                component: () => import("@/views/extend/index.vue"),
                name: "extend-list",
                meta: {
                    icon: "extend-off",
                    activeIcon: "extend-on",
                    title: "扩展组件",
                    roles: ["master", "sub"],
                    breadcrumb: false
                }
            }
        ]
    },
    {
        path: "/queue",
        redirect: "/queue/index",
        component: Layout,
        name: "queue",
        meta: {
            title: "工作负载",
            roles: ["master", "sub"]
        },
        children: [
            {
                path: "index",
                component: () => import("@/views/queue/index.vue"),
                name: "queue-list",
                meta: {
                    icon: "queue-off",
                    activeIcon: "queue-on",
                    title: "工作负载",
                    roles: ["master", "sub"],
                    breadcrumb: false
                }
            },
            {
                path: "detail",
                component: () => import("@/views/queue/detail.vue"),
                name: "queue-detail",
                hidden: true,
                meta: {
                    icon: "queue-off",
                    activeIcon: "queue-on",
                    title: "负载详情",
                    activeMenu: "/queue/index",
                    back: true,
                    roles: ["master", "sub"],
                    breadcrumb: false
                }
            }
        ]
    },
    {
        path: "/mirror",
        component: Layout,
        name: "mirror",
        redirect: "/mirror/prefab",
        meta: {
            icon: "mirror-off",
            activeIcon: "mirror-on",
            title: "镜像",
            roles: ["master", "sub"]
        },
        children: [
            {
                path: "",
                component: () => import("@/views/mirror/index.vue"),
                name: "mirror-overview",
                hidden: true,
                redirect: "/mirror/prefab",
                meta: {
                    title: "镜像",
                    roles: ["master", "sub"]
                },
                children: [
                    {
                        path: "prefab",
                        name: "Mirror-Prefab",
                        redirect: "/mirror/prefab/index",
                        meta: {
                            title: "预置镜像",
                            roles: ["master", "sub"],
                            breadcrumb: false
                        },
                        children: [
                            {
                                path: "index",
                                component: () => import("@/views/mirror/prefab.vue"),
                                name: "Prefab-index",
                                meta: {
                                    title: "预置镜像",
                                    roles: ["master", "sub"],
                                    breadcrumb: false,
                                    activeMenu: "/mirror"
                                }
                            },
                            {
                                path: ":name(.*)",
                                component: () => import("@/views/mirror/prefabTag.vue"),
                                name: "Prefab-Son",
                                meta: {
                                    title: "预置镜像",
                                    roles: ["master", "sub"],
                                    breadcrumb: false,
                                    activeMenu: "/mirror"
                                }
                            }
                        ]
                    },
                    {
                        path: "custom",
                        name: "Mirror-Custom",
                        redirect: "/mirror/custom/index",
                        meta: {
                            title: "自定义镜像",
                            roles: ["master", "sub"],
                            breadcrumb: false
                        },
                        children: [
                            {
                                path: "index",
                                component: () => import("@/views/mirror/custom.vue"),
                                name: "Custom-index",
                                meta: {
                                    title: "自定义镜像",
                                    roles: ["master", "sub"],
                                    breadcrumb: false,
                                    activeMenu: "/mirror"
                                }
                            },
                            {
                                path: ":name(.*)",
                                component: () => import("@/views/mirror/customTag.vue"),
                                name: "Custom-Son",
                                meta: {
                                    title: "自定义镜像",
                                    roles: ["master", "sub"],
                                    breadcrumb: false,
                                    activeMenu: "/mirror"
                                }
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        path: "/token",
        component: Layout,
        redirect: "/token/index",
        name: "access-token1",
        meta: {
            title: "访问令牌",
            roles: ["master", "admin", "sub"]
        },
        children: [
            {
                path: "index",
                component: () => import("@/views/containerService/token/index.vue"),
                name: "logIndex1",
                meta: {
                    title: "访问令牌",
                    roles: ["master", "admin", "sub"],
                    icon: "log-off",
                    activeIcon: "log-on",
                    breadcrumb: false
                }
            }
        ]
    }
];
export const specialRoutes = [
    {
        path: "/training",
        component: Layout,
        redirect: "/training/index",
        hidden: true,
        name: "training",
        meta: {
            title: "技术培训",
            roles: ["master"]
        },
        children: [
            {
                path: "index",
                component: () => import("@/views/training/index.vue"),
                name: "training-list",
                meta: {
                    title: "技术培训",
                    roles: ["master"],
                    breadcrumb: false
                }
            }
        ]
    }
];
export const asyncRoutes = [
    ...publicRoutes,
    ...resourceRoutes,
    ...modelAppRoutes,
    ...adminRoutes,
    ...accountRoutes,
    ...GPURoutes,
    ...helpRoutes,
    ...specialRoutes
];
const router = createRouter({
    history: createWebHistory(),
    routes: constantRoutes
});
export function resetRouter() {
    const routers = router.getRoutes();
    routers.map((it) => {
        if (!["login", "about", "modifyPassword"].includes(it.name)) {
            router.removeRoute(it.name);
        }
    });
}
export default router;
